import React from 'react';

const LoadingDots = () => (
  <div className="flex items-center space-x-1 px-2 py-1">
    <div className="w-2 h-2 dark:bg-white bg-black rounded-full animate-bounce" style={{ animationDelay: "0ms" }}></div>
    <div className="w-2 h-2 dark:bg-white bg-black rounded-full animate-bounce" style={{ animationDelay: "200ms" }}></div>
    <div className="w-2 h-2 dark:bg-white bg-black rounded-full animate-bounce" style={{ animationDelay: "400ms" }}></div>
  </div>
);

export default LoadingDots;